import * as React from "react";
import { CategoryDefinition } from "./endpointRegistry";
import { Note } from "components/form";
import ExternalLink from "components/Navigation/ExternalLink";

const category: CategoryDefinition = {
    category: "Azure",
    title: <React.Fragment>What type of <strong>Azure target</strong> do you want to connect?</React.Fragment>,
    help: <Note>Learn more about <ExternalLink href="AzureTargets">Azure Targets</ExternalLink></Note>,
    displayOrder: 30,
 };

export default category;
